import axios from 'axios';
import { QuoteItemTypes } from '@/common/constants/quote';
import { fcoUrl } from '../../fcoModules/utilities';

// PRIVATE VARS/FUNCTIONS
const quoteRESTPath = fcoUrl('/worksheet/rest');

/**
 * Convert a CompleteProduct to an AddProductDTO, in order to send a list of products to a service
 *     see:
 *         * AddProductDto.java
 *         * CompleteProduct.java
 * @param  {Object} completeProduct
 * @return {Object}
 */
function completeProductToAddProductDTO(completeProduct) {
    return {
        productKey: {
            productKeyType: 'LEGACY',
            groupId: completeProduct.legacyKey.groupId,
            itemId: completeProduct.legacyKey.itemId,
        },
        quantity: completeProduct.userSpecifiedQuantity,
        origin: completeProduct.productOrigin,
        productOriginDetails: completeProduct.productOriginDetails,
    };
}

const addProductsLegacy = (worksheetId, products, worksheetVehicleId = 0) =>
    axios.post(fcoUrl(`/worksheet/rest/${worksheetId}/addProducts/${worksheetVehicleId}`), products);

// PUBLIC METHODS
export const getQuote = (id, isEntSearchEnabled) =>
    isEntSearchEnabled ? axios.get(`${quoteRESTPath}/enterprise/${id}`) : axios.get(`${quoteRESTPath}/${id}`);

export const getMiniQuoteLegacy = () => axios.get(`${quoteRESTPath}/miniquote.json`);
export const getMiniQuote = (worksheetId) => axios.get(`${quoteRESTPath}/v2/miniquote/${worksheetId}`);

export const addProduct = (product, quantity) => axios.post(`${quoteRESTPath}/addproduct?quantity=${quantity}`, product);

export const addProducts = (worksheetId, products, worksheetVehicleId = 0, isEntSearchEnabled = true) =>
    isEntSearchEnabled
        ? axios.post(fcoUrl(`/worksheet/rest/enterprise/${worksheetId}/addProducts/${worksheetVehicleId}`), products)
        : addProductsLegacy(worksheetId, products, worksheetVehicleId);

export const addKitProducts = (products, isPrebuilt) => {
    const addKitPath = `${quoteRESTPath}/addkit${isPrebuilt ? '?prebuilt=true' : ''}`;
    return axios.post(addKitPath, products.map(completeProductToAddProductDTO));
};
export const addKitProductsEnterprise = ({ products, worksheetId, worksheetVehicleId, isPrebuilt }) => {
    const addKitPath = `${quoteRESTPath}/enterprise/addKit`;
    const requestDto = {
        addProductDtoList: products.map(completeProductToAddProductDTO),
        worksheetId,
        worksheetVehicleId,
        prebuilt: isPrebuilt,
    };
    return axios.post(addKitPath, requestDto);
};

export const saveLabor = ({ description, rate, hours }, saveLaborOptions = {}) => {
    const { isEntSearchEnabled, worksheetId, worksheetVehicleId, partTypeId, group, subgroup } = saveLaborOptions;
    const data = {
        description,
        customerPrice: rate,
        quantity: hours,
        type: QuoteItemTypes.LABOR,
        laborGroup: group,
        laborSubgroup: subgroup,
        laborPartTypeId: partTypeId,
    };
    const url = isEntSearchEnabled
        ? fcoUrl(`/worksheet/rest/enterprise/${worksheetId}/vehicle/${worksheetVehicleId}/nonProductItem`)
        : fcoUrl(`/worksheet/rest/${worksheetId}/vehicle/${worksheetVehicleId}/nonProductItem`);
    return axios.post(url, data);
};

const formatDate = (d) => (d ? new Date(d).toISOString().slice(0, 10) : null);

export const searchQuotes = ({ keywords, searchType, startDate, endDate }, shopId, isLong = false) =>
    axios.post(
        `${quoteRESTPath}/v2/search`,
        { keywords, searchType, startDate: formatDate(startDate), endDate: formatDate(endDate) },
        { params: { shopId, isLong } }
    );

export const getOrderStatus = (confirmationNumber) => axios.get(`${quoteRESTPath}/status`, { params: { confirmationNumber } });

export const newQuote = (shopId) => axios.post(`${quoteRESTPath}/new?shopId=${shopId}`);

export const clearQuote = () => axios.post(`${quoteRESTPath}/clear`);

export const addVehicleToQuote = (vehicleInfo, worksheetId) => axios.put(`${quoteRESTPath}/enterprise/${worksheetId}/addVehicle`, vehicleInfo);
